import React from "react";

function GasOutlet() {
  return (
    <>
      <style>{`
        .gas-outlet-container {
          padding: 2rem;
          background-color: #f5f7fa;
          font-family: 'Segoe UI', sans-serif;
        }

        .gas-outlet-container h1 {
          font-size: 2.5rem;
          text-align: center;
          color: #2c3e50;
          margin-bottom: 2rem;
        }

        .gas-outlet-container section {
          max-width: 900px;
          margin: 0 auto;
          background-color: #ffffff;
          padding: 2rem;
          border-radius: 10px;
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.06);
        }

        .gas-outlet-container img {
          display: block;
          width: 100%;
          max-width: 500px;
          margin: 1.5rem auto;
          border-radius: 10px;
          box-shadow: 0 2px 8px rgba(208, 179, 179, 0.1);
          clip-path: inset(1% 1% 1% 1%);
        }

        .gas-outlet-container p {
          font-size: 1.1rem;
          color: #555;
          line-height: 1.6;
          text-align: justify;
        }
          .gas-outlet-container span {
            display: block;
            text-align: center;
            color: blue;
            }
          

        @media (max-width: 768px) {
          .gas-outlet-container h1 {
            font-size: 2rem;
          }

          .gas-outlet-container p {
            font-size: 1rem;
          }

          .gas-outlet-container img {
            max-width: 90%;
          }
        }

        @media (max-width: 480px) {
          .gas-outlet-container {
            padding: 1rem;
          }

          .gas-outlet-container section {
            padding: 1.5rem;
          }

          .gas-outlet-container h1 {
            font-size: 1.6rem;
          }
        }
      `}</style>

      <main className="gas-outlet-container">
        <section>
          <h1>Gas Outlet (British Standard)</h1>
          <img src="gt1.png" alt="Gas Terminal" />
          <p>
            The range of gas outlet point (front loaded) we offer to clients
            comprises of the same features as hook loose type have. These also
            come with a non-interchangeable self-sealing quick connect gas
            outlet for Oxygen, N₂O, Vacuum, C.A.4, C.A.7, and CO₂. Our products
            are also checked on stringent quality parameters to ensure they are
            made as per ISO standards and specifications, before being delivered
            to the client’s end.
          </p>
          <img src="gt2.png" alt="Gas Terminal" />
          <span>Adapter BS Outlets</span>
        </section>
      </main>
    </>
  );
}

export default GasOutlet;
